import { ReactNode } from 'react'
import { useNavigate } from 'react-router-dom'

import ConvexErrorBoundary from './ConvexErrorBoundary'

interface Props {
  children: ReactNode
}

/**
 * Wrapper that provides navigate function to ConvexErrorBoundary
 */
const ConvexErrorBoundaryWrapper = ({ children }: Props) => {
  const navigate = useNavigate()

  return (
    <ConvexErrorBoundary navigate={navigate}>{children}</ConvexErrorBoundary>
  )
}

export default ConvexErrorBoundaryWrapper
